<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one swiper-no-swiping">
        <video
          src="../assets/img/home.mp4"
          autoplay
          loop
          muted
          style="width: 100%; height: 100%; object-fit: cover; position: absolute; top: 0; left: 0;"
        />
        <!-- <div class="page">
          <h3>中启联信科技集团</h3>
          <p>ZQLINX TECH GROUP</p>
        </div>
        <p class="slogan">让数据价值的流动 像自来水一样即开即用</p> -->
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two swiper-no-swiping">
        <div class="page-1">
          <div class="displayFlex" style="margin-top: 80px;">
            <div class="page-1-left">
              <div class="gyzq">
                <h2 class="gyzq-title">关于中启联信</h2>
                <h3 class="gyzq-content">ZQLINX TECH GROUP</h3>
                <div class="gyzq-text" style="margin-bottom: 0;">
                  中启联信科技集团有限公司是国家科技型中小企业，以“让数据成为资产，让AI创造效益”为核心使命，致力于成为数据要素全生命周期管理与AI技术落地的行业引领者。中启联信科技集团专注于数据资产化运营与AI技术研发，依托自有标注基地与ISQ双认证，构建了“采集、标注、训练、运营”的完整技术闭环。集团拥有百万级多模态高质量数据集，已服务十余家头部AI企业，支撑多领域创新。通过“AI+数据”双轮驱动，为政企客户提供数据标注、模型训练及AI解决方案全链条服务，并与上市公司、福建大数据交易所等协同，推动数据要素产业化发展。

                </div>
                <div class="gyzq-text" style="margin-top: 0;">
                  主要的产品和服务有:
                  数据资产入表,数据标注,数据交易,AI模型训练,智能体搭建及本地化部署,
                  大数据AI舆情监测系统 , 信速察品宣智检系统,
                  AI一体机,AI智能体研发, Ai数字人,中启手语通翻译系统等
                </div>
              </div>
            </div>
            <div class="page-1-right">
              <video
                src="../assets/img/home2.mp4"
                style="width:800px;height:450px;"
                autoplay
                loop
                controls
              ></video>
            </div>
          </div>
          <ul
            style="display: flex;justify-content: space-between;margin-top:100px;"
          >
            <li class="li1">
              <img src="../assets/img/x1.png" style="width: 50px;" />
              <div class="li-num">
                <ICountUp :delay="0" :duration="3000" :endVal="num1" /><span
                  class="num-em"
                  >+</span
                >
              </div>
              <div class="li-text">客户选择</div>
            </li>
            <li class="li1">
              <img src="../assets/img/x2.png" style="width: 50px;" />
              <div class="li-num">
                <div class="li-num">
                  <ICountUp :delay="100" :endVal="num2" /><span class="num-em"
                    >+</span
                  >
                </div>
              </div>
              <div class="li-text">已上线数据服务产品</div>
            </li>
            <li class="li1">
              <img src="../assets/img/x3.png" style="width: 50px;" />
              <div class="li-num">
                <ICountUp :delay="4" :endVal="num3" /><span class="num-em"
                  >+</span
                >
              </div>
              <div class="li-text">已接入政务数据资源</div>
            </li>
            <li class="li1">
              <img src="../assets/img/x4.png" style="width: 50px;" />
              <div
                class="li-num"
                style="font-family: DINCond-Bold;font-weight: bold;"
              >
                ∞
              </div>
              <div class="li-text">高质量数据集</div>
            </li>
          </ul>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-three swiper-no-swiping">
        <div class="page-2">
          <div class="page-2-title">产品方案</div>
          <div class="page-2-solgan">product solution</div>
          <div class="title-bg">核心业务板块</div>
          <ul style="display: flex;gap: 10px;margin-bottom: 10px;">
            <li class="li2 bg1" @click="go('/news')">
              <div class="center-text">AI定制化赋能</div>
            </li>
            <li class="li2 bg2" @click="go('/sjbz')">
              <div class="center-text">数据标注服务</div>
            </li>
          </ul>
          <ul style="display: flex;gap: 10px;margin-bottom: 10px;">
            <li class="li2 bg3" @click="go('/download')">
              <div class="center-text">政企数据资产</div>
            </li>
            <li class="li2 bg4" @click="go('/product')">
              <div class="center-text">数据产业赋能</div>
            </li>
          </ul>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two swiper-no-swiping">
        <div class="page-3">
          <div class="page-3-title">企业理念</div>
          <div class="page-3-solgan">corporate philosophy</div>
          <div style="position: relative;">
            <img
              style="width: 100%;height: 725px;"
              src="../assets/img/bg3.png"
              alt=""
            />
            <div class="divbox">
              <div class="div-left">
                <img src="../assets/img/font1.png" alt="" />
              </div>
              <div class="div-right">
                <img src="../assets/img/font2.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide
        class="swiper-slide slide-four swiper-no-swiping"
        style="position: relative;"
      >
        <div class="box4">
          <div class="page-3-title">新闻资讯</div>
          <div class="page-3-solgan">News and Information</div>
          <div class="box-flex">
            <div class="left">
              <el-carousel indicator-position="outside" height="350px">
                <el-carousel-item v-for="(item, index) in newList" :key="index">
                  <img style="width: 100%;" :src="item.img" />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="right">
              <div
                style="display: flex;border-bottom: 1px solid #e0e0e0;padding: 20px;cursor: pointer;"
                v-for="(item, index) in newList"
                :key="index"
                @click="changeUrl(item)"
              >
                <div class="time">
                  <div class="day">{{ item.day }}</div>
                  <div class="month">{{ item.month }}</div>
                </div>
                <div class="contentss">
                  <div class="title-1">{{ item.title }}</div>
                  <div class="text-1">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="more" @click="$router.push('/moreNews')">查看更多</div>
        </div>
        <div class="footers">
          <div class="footer-content">
            <ul class="content-nav">
              <li>
                <p>友情链接</p>
                <span @click="golink('https://www.nda.gov.cn/sjj/index_pc.html')">国家数据局</span>
                <span @click="golink('https://www.fjbdex.com/#/home')">福建大数据交易所</span>
                <span @click="golink('https://data.zqlinx.com/#/')">中启联信数据中心</span>
                <span @click="golink('http://mjaidata.zqlinx.com/#/')">中启联信数据工厂</span>
              </li>
              <li>
                <p>产品中心</p>
                <span @click="go('/news')">数据交易一体机</span>
                <span @click="go('/sjzcyy')">公共数据服务平台</span>
                <span @click="go('/sjbz')">AI数据标注服务</span>
              </li>
              <li>
                <p>数据服务</p>
                <span @click="go('/product')">数据资产登记</span>
                <span @click="go('/sjkxjf')">数据治理服务</span>
                <span @click="go('/download')">数据资产入表</span>
              </li>
              <li>
                <p>关于我们</p>
                <span @click="go('/case')">中启联信</span>
                <span @click="go('/sjzcyy')">数据资产增值</span>
                <span @click="go('/case?index=3')">数据服务资讯</span>
              </li>
              <li>
                <p>联系我们</p>
                <span>邮箱：market@zqlinx.com</span>
                <span>电话：0591-38205606/13328653291</span>
                <span
                  >联系地址：福建省福州市鼓楼区软件大道89号福州软件园F区5号楼8层</span
                >
              </li>
            </ul>

            <img src="@/assets/img/swqr.png" alt />
          </div>
          <div style="color: #fff;text-align: center;font-size: 14px;cursor: pointer;" @click="goba">Copyright © 2026 中启联信科技集团公司版权所有<img style="width: 16px;margin: 0 4px -3px 8px;" src="../assets/img/gh.webp" />  闽ICP备2024080147号-1</div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import ICountUp from "vue-countup-v2";
import newList  from "./data";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide,
    ICountUp,
  },
  metaInfo: {
    title: "中启联信_数据资产_AI赋能",
    meta: [
      {
        name: "keywords",
        content:
          "中启联信、AI赋能、AI定制化、AI一体机、AI私域、信速查、舆情监测、舆情处置、网站合规校验、网站巡检、新媒体巡检、错敏词校对、图文合规校对、高校AI、AI助教、新媒体运维、微信整合运维、AI文生图、AI内容生成、AI数字人、AI手语翻译、手语转译、AI低空经济、AI解决方案、数据资产、数据资产入表、数据标注、数据资产运营、数据监理、数据可信交付",
      },
      {
        name: "description",
        content:
          "中启联信科技集团以“让数据成为资产，让AI创造效益”为核心使命，致力于成为数据要素全生命周期管理与AI技术落地的行业引领者。",
      },
    ],
  },
  data() {
    return {
      newList: newList.slice(0,3),
      num1: 300,
      num2: 250,
      num3: 570,
      loading: false,
      caseList: [],
      newsList: [],
      swiperOption: {
        noSwap: true,
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        // grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          slideChange: () => {
            let swiper = this.$refs.mySwiper.swiper;
            // console.log(swiper.activeIndex); //滑动打印当前索引
            if (swiper.activeIndex == 1) {
              this.num1 = 0;
              this.num2 = 0;
              this.num3 = 0;
              setTimeout(() => {
                this.num1 = 300;
                this.num2 = 250;
                this.num3 = 570;
              }, 100);
            }
            if (swiper.activeIndex == 3) {
              this.checkPosition(swiper.activeIndex);
            } else {
              this.checkPosition(swiper.activeIndex);
            }
            //console.log(swiper.activeIndex); //滑动打印当前索引
            // if (swiper.activeIndex === this.list.length - 1) {
            //   //到最后一个加载更多数据
            //   let newList = [];
            //   let listLength = this.list.length;
            //   for (let i = 0; i < 10; i++) {
            //     newList.push(listLength + i);
            //   }
            //   this.list = this.list.concat(newList);
            // }
          },
        },
      },
    };
  },
  created() {},
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    // this.checkPosition();
  },
  methods: {
    goba(){
      window.open('https://beian.miit.gov.cn/')
    },
    golink(link) {
      window.open(link);
    },
    go(path) {
      this.$router.push(path);
    },
    changeUrl(item) {
      window.open(item.url);
    },
    checkPosition(index) {
      const element = document.querySelector(".div-left");
      const element2 = document.querySelector(".div-right");
      // const rect = element.getBoundingClientRect();
      // console.log(rect);
      if (index == 3) {
        // 假设0是你想要的顶部阈值
        element.classList.add("animate");
        element2.classList.add("animate1");
      } else {
        element.classList.remove("animate");
        element2.classList.remove("animate1");
      }
      window.addEventListener("scroll", this.checkPosition);
      // this.checkPosition(); // 初始检查位置
    },
  },
};
</script>

<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */

.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;
    h3 {
      font-size: 40px;
      font-weight: bold;
      color: #fff;
    }
    p {
      font-size: 32px;
      font-weight: 400;
      color: #f9f9f9;
    }
  }

  .slogan {
    text-align: center;
    font-size: 36px;
    color: #fff;
    padding: 30px 0;
  }
}
.bg1 {
  background: url(../assets/img/cp1.png) no-repeat;
}
.bg2 {
  background: url(../assets/img/cp2.png) no-repeat;
}
.bg3 {
  background: url(../assets/img/cp3.png) no-repeat;
}
.bg4 {
  background: url(../assets/img/cp4.png) no-repeat;
}
.li2 {
  height: 330px;
  width: calc(50% - 5px);
  background-size: auto 100% !important;
  position: relative;
  overflow: hidden;
  transition: all 0.5s;
  &:hover {
    width: calc(68% - 5px);
  }
  .center-text {
    position: absolute;
    color: #fff;
    text-align: center;
    font-size: 40px;
    width: 100%;
    top: 50%;
    margin-top: -50px;
    line-height: 100px;
    height: 100px;
  }
}
.footers {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 236px;
  overflow: hidden;
  // background-color: #14679f;
  background-image: url(../assets/img/footer.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  &-content {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-size: 14px;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
.more{
    text-align: center;
    margin-top: 30px;
    font-size: 18px;
    cursor: pointer;
    &:hover{
      color: #1266ec;
    }
  }
.box4 {
  width: 1400px;
  margin: 100px auto;
  padding-bottom: 300px;
  .page-3-title {
    // margin-top: 40px;
    display: block;
    width: 1400px;
    margin: 130px auto 20px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #333;
  }
  .page-3-solgan {
    display: block;
    width: 1400px;
    margin: 0 auto 40px;
    text-align: center;
    font-size: 28px;
    text-transform: uppercase;
    color: #8e96a1;
    letter-spacing: 3px;
  }
  .box-flex {
    display: flex;
    .left {
      width: 48%;
      margin-right: 40px;
    }
    .right {
      width: 48%;
      .contentss {
        flex-shrink: 0;
        margin-left: 10px;
        .title-1 {
          font-size: 18px;
          width: 540px;
        }
        .text-1 {
          margin-top: 8px;
          font-size: 16px;
          color: #686868;
          line-height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          width: 540px;
        }
      }

      .time {
        flex-shrink: 0;
        text-align: center;
        .day {
          font-size: 32px;
          font-weight: bold;
          color: #3a4354;
        }
        .month {
          margin-top: 10px;
          font-size: 20px;
          color: #3a4354;
        }
      }
    }
  }
}
.page-3 {
  display: block;
  width: 100%;
  margin: auto;
  .page-3-title {
    // margin-top: 40px;
    display: block;
    width: 1400px;
    margin: 130px auto 20px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #333;
  }
  .page-3-solgan {
    display: block;
    width: 1400px;
    margin: 0 auto 40px;
    text-align: center;
    font-size: 28px;
    text-transform: uppercase;
    color: #8e96a1;
    letter-spacing: 3px;
  }
  .divbox {
    position: absolute;
    top: 10px;
    left: 50%;
    width: 1100px;
    transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .div-left {
      position: relative; /* 或者 absolute，取决于你的布局需求 */
      transition: transform 1s ease; /* 动画效果 */
      transform: translatex(-1450px); /* 初始位置，根据需要调整 */
      .left-text {
        font-size: 60px;
        padding: 40px 0;
        color: #fff;
      }
    }
    .animate {
      transform: translatex(-450px);
    }
    .animate1 {
      transform: translatex(-2300px) !important;
    }
    .div-right {
      position: relative; /* 或者 absolute，取决于你的布局需求 */
      transition: transform 1s ease; /* 动画效果 */
      transform: translatex(-1300px); /* 初始位置，根据需要调整 */
      .right-text {
        font-size: 60px;
        padding: 40px 0;
        color: #fff;
      }
    }
  }
}
.page-2 {
  display: block;
  width: 1400px;
  margin: auto;
  .page-2-title {
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #333;
    padding: 80px 0 40px 0;
  }
  .page-2-solgan {
    text-align: center;
    font-size: 28px;
    text-transform: uppercase;
    color: #8e96a1;
    letter-spacing: 3px;
  }
  .title-bg {
    display: inline-block;
    color: #fff;
    line-height: 37px;
    padding: 0 45px 0 25px;
    border-radius: 20px 0 0 0;
    font-size: 25px;
    background: url(../assets/img/titbg09.png) no-repeat center right;
    background-size: cover;
  }
}
.page-1 {
  unicode-bidi: normal;
  background: #fff;
  display: block;
  width: 1400px;
  margin: auto;
  .li1 {
    text-align: center;
    list-style: none;
    .li-num {
      margin-top: 12px;
      font-size: 80px;
      color: #1854f2;
      line-height: 1;
      // font-family: DINCond-Bold;
      .num-em {
        font-size: 25px;
        color: #1854f2;
        font-weight: bold;
        margin-left: 5px;
      }
    }
    .li-text {
      margin-top: 12px;
      font-size: 16px;
      color: #8e96a1;
      text-align: center;
    }
  }
  .li2 {
    list-style: none;
  }
  .li3 {
    list-style: none;
  }
  .li4 {
    list-style: none;
  }
  .displayFlex {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .page-1-left {
      width: 40%;
      .gyzq {
        position: relative;
        padding-left: 45px;
        ::after {
          position: absolute;
          content: "";
          width: 30px;
          height: 30px;
          background: #1854f2;
          border-radius: 0 0 20px 0;
          left: 0;
          top: 9px;
        }
        .gyzq-content {
          margin-top: 12px;
          font-size: 24px;
          color: #8e96a1;
        }
        .gyzq-text {
          font-size: 18px;
          color: #8e96a1;
          line-height: 1.8;
          text-align: justify;
          margin: 10px 0 45px 0;
        }
      }
    }
    .page-1-right {
      width: 55%;
      display: flex;
      align-items: center;
      justify-content: center;
      .page-1-right video {
        max-width: 100%;
        height:auto;
        display: block;
      }
    }
  }
}
//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    width: 330px;
    height: 250px;
    border-radius: 12px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.7);

  .hover-title {
    margin-top: 12px;
    margin-left: 12px;
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  // background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}
.slide-two {
  // background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-three {
  background-color: #fafafa;
  // background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}
//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
</style>
